/* Generated by restful-react */

import React from 'react'
import {
  Get,
  GetProps,
  useGet,
  UseGetProps,
  Mutate,
  MutateProps,
  useMutate,
  UseMutateProps,
} from 'restful-react'

export interface LaneLocation {
  stateCode?: string
  countryCode?: string
  city?: string
  radius?: number
}

export type RateType = 'flat_rate' | 'fuel_surcharge'

export interface ShipperCityCarrierLane {
  id: number
  shipperCityLaneId: number
  carrierApplicationId: number
  rateType: RateType
  isDropTrailer: boolean
  delivery: LaneLocation
  pickup: LaneLocation
  shipperApplicationName: string
}

export interface ShipperCityCarrierLanesResponse {
  shipperCityCarrierLanes: ShipperCityCarrierLane[]
  nextPage: boolean
  totalCount: number
}

export interface ShipperCityCarrierLaneUpdate {
  shipperCityCarrierLane: {
    rateType: RateType
  }
}

export interface ShipperCityCarrierLaneFilters {
  carrierApplicationId?: number
  shipperCityLaneId?: number
  rateType?: RateType
}

export interface ErrorResponse {
  errors: string[]
}

export interface GetShipperCityCarrierLanesQueryParams {
  /**
   * Filters
   */
  filters?: ShipperCityCarrierLaneFilters
  /**
   * Page Count
   */
  pageCount?: number
  /**
   * Per Page Size
   */
  pageSize?: number
}

export type GetShipperCityCarrierLanesProps = Omit<
  GetProps<
    ShipperCityCarrierLanesResponse,
    ErrorResponse,
    GetShipperCityCarrierLanesQueryParams,
    void
  >,
  'path'
>

/**
 * All shipper city carrier lanes for a carrier
 */
export const GetShipperCityCarrierLanes = (props: GetShipperCityCarrierLanesProps) => (
  <Get<ShipperCityCarrierLanesResponse, ErrorResponse, GetShipperCityCarrierLanesQueryParams, void>
    path='/v9/shipper_city_carrier_lanes'
    {...props}
  />
)

export type UseGetShipperCityCarrierLanesProps = Omit<
  UseGetProps<
    ShipperCityCarrierLanesResponse,
    ErrorResponse,
    GetShipperCityCarrierLanesQueryParams,
    void
  >,
  'path'
>

/**
 * All shipper city carrier lanes for a carrier
 */
export const useGetShipperCityCarrierLanes = (props: UseGetShipperCityCarrierLanesProps) =>
  useGet<
    ShipperCityCarrierLanesResponse,
    ErrorResponse,
    GetShipperCityCarrierLanesQueryParams,
    void
  >(`/v9/shipper_city_carrier_lanes`, props)

export interface UpdateShipperCityCarrierLanePathParams {
  /**
   * The id of the shipper city carrier lane.
   */
  laneId: number
}

export type UpdateShipperCityCarrierLaneProps = Omit<
  MutateProps<
    ShipperCityCarrierLane,
    ErrorResponse,
    void,
    ShipperCityCarrierLaneUpdate,
    UpdateShipperCityCarrierLanePathParams
  >,
  'path' | 'verb'
> &
  UpdateShipperCityCarrierLanePathParams

/**
 * Update the rate type of a shipper city carrier lane
 */
export const UpdateShipperCityCarrierLane = ({
  laneId,
  ...props
}: UpdateShipperCityCarrierLaneProps) => (
  <Mutate<
    ShipperCityCarrierLane,
    ErrorResponse,
    void,
    ShipperCityCarrierLaneUpdate,
    UpdateShipperCityCarrierLanePathParams
  >
    verb='PUT'
    path={`/v9/shipper_city_carrier_lanes/${laneId}`}
    {...props}
  />
)

export type UseUpdateShipperCityCarrierLaneProps = Omit<
  UseMutateProps<
    ShipperCityCarrierLane,
    ErrorResponse,
    void,
    ShipperCityCarrierLaneUpdate,
    UpdateShipperCityCarrierLanePathParams
  >,
  'path' | 'verb'
> &
  UpdateShipperCityCarrierLanePathParams

/**
 * Update the rate type of a shipper city carrier lane
 */
export const useUpdateShipperCityCarrierLane = ({
  laneId,
  ...props
}: UseUpdateShipperCityCarrierLaneProps) =>
  useMutate<
    ShipperCityCarrierLane,
    ErrorResponse,
    void,
    ShipperCityCarrierLaneUpdate,
    UpdateShipperCityCarrierLanePathParams
  >(
    'PUT',
    (paramsInPath: UpdateShipperCityCarrierLanePathParams) =>
      `/v9/shipper_city_carrier_lanes/${paramsInPath.laneId}`,
    { pathParams: { laneId }, ...props }
  )
